import React from "react";

export const FilterIcon = () => {
  return (
    <>
      <svg
        width="20"
        height="13"
        viewBox="0 0 20 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 1H19M4.37493 6.5H15.6249M8.87489 12H11.1249"
          stroke="#231F20"
          style={{
            stroke: "#231F20",
            stroke: "color(display-p3 0.1373 0.1216 0.1255)",
            strokeOpacity: 1,
          }}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
